import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils } from '@shared/utils';
import { PaymentApi } from '@shared/api';

export const generateOutgoingPaymentEffect = createEffect((id: string) => PaymentApi.generateOutgoingPayment(id));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(generateOutgoingPaymentEffect.pending, (_, data) => data)
  .on(generateOutgoingPaymentEffect.fail, () => false)
  .on(generateOutgoingPaymentEffect.done, () => false)
  .reset(clearEvent);

generateOutgoingPaymentEffect.done.watch((result) => FileUtils.downloadFile(result.result, `Deposit Payment Report - ${result.params}`));
generateOutgoingPaymentEffect.fail.watch(() =>
  $notificationStore.events.setError('Something went wrong while downloading Payment Report. Please try again.'),
);

export const $generateOutgoingPaymentStore = {
  events: {
    generateOutgoingPayment: generateOutgoingPaymentEffect,
    clear: clearEvent,
  },
  store: combine({ loading: $loadingStore }),
};
